import config from 'config';
import { SidebarNodeType } from 'config/routes/skeleton/SidebarNode';
import axiosClient from 'config/axios';

export const getFavouritesNavigation = (): Promise<{ favorites?: SidebarNodeType[] }> =>
    axiosClient.get(`${config.cmsUrl}/navigation-bar/configurations`).then((response) => response.data.payload);

export const setFavouritesNavigation = (payload: SidebarNodeType[]): Promise<SidebarNodeType[]> =>
    axiosClient
        .post(`${config.cmsUrl}/navigation-bar/configurations`, { favorites: payload })
        .then((response) => response.data.payload.favorites);

export const editFavouritesNavigation = (payload: SidebarNodeType[]): Promise<SidebarNodeType[]> =>
    axiosClient
        .put(`${config.cmsUrl}/navigation-bar/configurations`, { favorites: payload })
        .then((response) => response.data.payload.favorites);

export const saveFavouritesNavigation = async (payload: SidebarNodeType[], isInitial: boolean) => {
    if (isInitial) {
        return setFavouritesNavigation(payload);
    }
    return editFavouritesNavigation(payload);
};
